import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessNeighbours } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canAccessBulkUploadUsers, canInviteUser } from "./permissions";
import { usersRoutes } from "./routes";

export const usersRoute = [
  {
    path: usersRoutes.list,
    lazy: async () => {
      const { UserListPage } = await import("./pages/list/UserListPage");

      return {
        element: (
          <RequireAuth permission={canAccessNeighbours}>
            <UserListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: usersRoutes.details,
    lazy: async () => {
      const { UserDetailsPage } = await import("./pages/details/UserDetailsPage");

      return { element: <UserDetailsPage /> };
    },
  },
  {
    path: usersRoutes.new,
    lazy: async () => {
      const { CreateUserPage } = await import("./pages/create-or-edit/CreateUserPage");

      return {
        element: (
          <RequireAuth permission={canInviteUser}>
            <CreateUserPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: usersRoutes.edit,
    lazy: async () => {
      const { EditUserPage } = await import("./pages/create-or-edit/EditUserPage");

      return {
        element: (
          <RequireAuth permission={(x) => x.isAdmin}>
            <EditUserPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: usersRoutes.editSelf,
    lazy: async () => {
      const { ResidentEditSelfPage } = await import("./pages/resident-edit-self/ResidentEditSelfPage");

      return { element: <ResidentEditSelfPage /> };
    },
  },
  {
    path: usersRoutes.bulkUpload,
    lazy: async () => {
      const { UserBulkUploadPage } = await import("./pages/bulk-upload/UserBulkUploadPage");

      return {
        element: (
          <RequireAuth permission={canAccessBulkUploadUsers}>
            <UserBulkUploadPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
